import { render } from "./SyndicationMarketplace.vue.js?vue&type=template&id=1e1ceea2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicationMarketplace.vue?vue&type=template&id=1e1ceea2"
import script from "./SyndicationMarketplace.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicationMarketplace.vue?vue&type=script&lang=js"
export * from "./SyndicationMarketplace.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicationMarketplace.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/settings/SyndicationMarketplace.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e1ceea2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e1ceea2', __exports__)) {
    api.reload('1e1ceea2', __exports__)
  }
  
  module.hot.accept("./SyndicationMarketplace.vue.js?vue&type=template&id=1e1ceea2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicationMarketplace.vue?vue&type=template&id=1e1ceea2", () => {
    api.rerender('1e1ceea2', render)
  })

}


export default __exports__